export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SEND_NOTIFICATION = 'SEND_NOTIFICATION';
export const SYNC_NOTIFICATIONS = 'SYNC_NOTIFICATIONS';
export const UPDATE_UNREAD_COUNT = 'UPDATE_UNREAD_COUNT';
export const UPDATE_READ_NOTIFICATION = 'UPDATE_READ_NOTIFICATION';
export const ADMIN_SEND_NOTIFICATION = 'ADMIN_SEND_NOTIFICATION';

export interface NotificationProps {
  id: string;
  senderid: string;
  order: string;
  action: string;
  timeadded: number;
  read: boolean;
  reason: string;
  mealname: string;
}

export interface Notifications {
  notification: NotificationProps[];
  isLoading: boolean;
  unread: number;
}

export interface SendProps {
  order?: string;
  reason: string;
  mealname?: string;
  action: string;
}

export interface GetNotificationsAction extends Notifications {
  type: typeof GET_NOTIFICATIONS;
}

export interface SetNotificationsAction extends Notifications {
  type: typeof SET_NOTIFICATIONS;
  notification: NotificationProps[];
  unread: number;
}

export interface SendNotification {
  type: typeof SEND_NOTIFICATION;
  send: SendProps;
  receiver?: string;
}

export interface SendNotification {
  type: typeof SEND_NOTIFICATION;
  send: SendProps;
  receiver?: string;
}

export interface SyncNotification {
  type: typeof SYNC_NOTIFICATIONS;
}

export interface UpdateReadCount extends Notifications {
  type: typeof UPDATE_UNREAD_COUNT;
}

export interface UpdateReadNotification {
  type: typeof UPDATE_READ_NOTIFICATION;
  id: string;
}

export type NotificationActionTypes =
  | GetNotificationsAction
  | SetNotificationsAction
  | UpdateReadCount;
